import { useCallback } from 'react';
import {
    ONBOARDING_HAS_CLICKED_ON_PUBLISH_STORAGE_KEY,
    ONBOARDING_KIT_STEPS,
    useOnboardingStage,
} from '#shared/api/onboarding';
import { infoSrc } from '#shared/assets';
import { useConfirm } from '#shared/lib/hooks';
import { openInNewTab, useNavigateWithSearchParams } from '#shared/lib/router';
import { settingsDomainRoute, settingsTestOrderRoute } from '#shared/lib/routes';
import { persistentStorage } from '#shared/lib/storage';
import { type VariantPublishButtonProps } from '../OnboardingStepsRenderer';
import { PublishButton } from '../PublishButton';

export function KitPublishButton({ name, isDisabled, 'data-testid': dataTestId }: VariantPublishButtonProps) {
    const { isLoading } = useOnboardingStage(ONBOARDING_KIT_STEPS.PUBLISH);
    const { renderConfirmModal, confirm } = useConfirm();
    const navigate = useNavigateWithSearchParams();

    const handleClick = useCallback(() => {
        confirm({
            imageSrc: infoSrc,
            title: 'Сделайте тестовый заказ',
            bodyText: 'Проверьте корректность работы перед публикацией сайта.',
            applyText: 'Сделать тестовый заказ',
            onApply: () => {
                openInNewTab(settingsTestOrderRoute.getUrl());
            },
            cancelText: 'Опубликовать магазин',
            onCancel: () => {
                persistentStorage.setItem(ONBOARDING_HAS_CLICKED_ON_PUBLISH_STORAGE_KEY, '1');
                navigate(settingsDomainRoute.getUrl());
            },
        });
    }, [confirm, navigate]);

    return (
        <>
            {renderConfirmModal()}
            <PublishButton
                data-testid={dataTestId}
                name={name}
                isDisabled={isDisabled}
                isLoading={isLoading}
                onClick={handleClick}
                tooltip="Чтобы опубликовать сайт — выполните все предыдущие шаги"
            />
        </>
    );
}
